import React from "react"
import {useState, useEffect} from "react"
import './TApp.css'
import FadeLoader from "react-spinners/FadeLoader"
import searchIcon from "./search.svg"
import AnimeCard from "./AnimeCard.js" 


function TApp() {

  const [animeItem, setanimeItem] = useState("naruto") 
  const [animeList, setAnimeList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [search, setSearch] = useState("") 
  

  let color = "darkslategrey"  

  const fetchAnime = async () => {
    setIsLoading(true)
    const resData = await fetch(`https://api.jikan.moe/v4/anime?q=${animeItem}&slimit=50`)
    const animeJson = await resData.json() 
    console.log(animeJson.data)
    setAnimeList(animeJson.data)
    setIsLoading(false)
  }
  const changeAnime = () => {
    setanimeItem(search)
  }
  useEffect(() => {
    fetchAnime(animeItem)
  }, [animeItem])

  return ( 
    <div className="App">
      <h1>AnimeFlix</h1>

      <div id="input-section">
        <div id="search-section">
          <div>
          <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..."/> </div>
          {/* <button onClick={changeAnime}>Search</button> */}
          <img className="search-button" src={searchIcon} onClick={changeAnime} />
          {/* {console.log(animeItem)} */}
        </div>
      </div>

      <div id="loading-anime">
        {
          isLoading ? (
            <div id="react-loading">
              <FadeLoader color={color} /> 
              <div id="container">
                <p>Fetching Images</p>
              </div>
            </div>
            ) : 
          (<div id="anime">
            {
              animeList.length !== 0 ? (
                // <AnimeCard anime={animeList} className="import" />
                animeList.map(anime => {
                  return (
                    <div className="img-container">
                      <img className="anime-img" src={anime.images.jpg.large_image_url} />
                      <h4>{anime.title}</h4>
                    </div>
                  )
                })
              ) : <p style={{color: "white"}}>Anime not found</p>
            }
          </div>
        )
      }
      </div>
    </div>
  );
}

export default TApp;